// Module
var code = "<table id=\"V-48358515-0456-4D23-A3FA-8B0925CE1AB1\"> <tbody data-b-itemsSource=\"{Binding items,ViewSelector:templateSelector}\" data-b-class-displaycontent=\"{Binding displayContentForTBody}\"> </tbody> </table> ";
// Exports
export default code;